export const wrapRootElement = () => {
  return <div style={{ background: "#fff", width: "100vw", height: "100vh" }} />;
};
